import { useEffect, useState } from 'react'
import { debug as dbg } from 'debug'
import { getConfiguredClient } from 'util/graphqlClient'
import gql from 'graphql-tag'

const debug = dbg('util:stripe:details')

export function useStripe() {
  const [Stripe, setStripe] = useState(null)
  const [error, setError] = useState(null);


  useEffect(() => {
    if (Stripe) return
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = 'https://js.stripe.com/v3/'

    document.head.appendChild(script)
    script.onload = function () {
      setStripe(() => window.Stripe)
      debug('stripe loaded')
    }
    script.onerror = () => {
      setError(
        new error('Failed loading required resource, please try reloading page or contact support if problem persists')
      )
    }

    return () => script.remove()
  }, [])

  return [Stripe, error]
}

const addCreditCard = gql`
  mutation ($stripeToken: String) {
    addCustomerCreditCard(stripeToken: $stripeToken) {
      profileStatus
      creditCard {
        expMonth
        expYear
        last4
      }
    }
  }`


export const checkCard = (stripe, card, onSuccess, onError,refetchQueries) => async () => {
  const {token, error} = await stripe.createToken(card)
  if(error) {
    onError(error.message)
  }
  if (token) {
    const mutateConfig = {
      mutation: addCreditCard,
      variables: {
        stripeToken: token.id
      }
    }

    if(refetchQueries) {
      mutateConfig.refetchQueries = [refetchQueries]
    }

    const {data} = await getConfiguredClient().mutate(mutateConfig)
    if (data.addCustomerCreditCard) {
      const cardValues = {
        last4: token.card.last4,
        expMonth: token.card.exp_month,
        expYear: token.card.exp_year
      }
      card.destroy()
      onSuccess(cardValues)
    } else {
      /** @todo card elemeent should be cleared if an error happens, but `card.clear()` focuses the element and
       * triggers the validation which overrides the error message below
       */
      // card.clear()
      onError(intl.formatMessage({id: 'component.customerDetails.failedStoringCard'}))
    }
  }
}



// WEBPACK FOOTER //
// ./util/Stripe.js